export const ANOMALY_RESOLUTION_MODAL_INTRO_TEXT =
  "You can add comments regarding your decision here.";
export const ANOMALY_HEADER_SECTION_TEST_ID = "anomaly-header-section";
